<div class="modal-header">
    <h5 class="modal-title">Ajouter une note</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="noteForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="type">Type de note</label>
        <select formControlName="type" class="form-control" id="type">
          <option value="public">Publique</option>
          <option value="restreint">Restreinte</option>
          <option value="private">Privée</option>
        </select>
      </div>
      <div class="form-group">
        <label for="texte">Contenu de la note</label>
        <textarea formControlName="texte" id="texte" class="form-control"></textarea>
      </div>
      <button type="submit" class="btn btn-primary">Ajouter la note</button>
    </form>
  </div>
  